function A(e){let r={};for(let o of e)r={...r,...o};return r}export{A as a};
